import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "TextCta",
    component: () => (__SERVER__ ? require("./text-cta-view") : import("./text-cta-view"))
});

export default definition;
